import styled from "styled-components";
import { MapContainer } from "react-leaflet";

export const Wrapper = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* empurra o footer para o fim */
  background-color: #f4f4f4;
`;


export const Sidebar = styled.div`
  width: 240px;
  background-color: #1e293b;
  color: white;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

export const SidebarTitle = styled.h2`
  margin-bottom: 20px;
  font-size: 20px;
  font-weight: bold;
`;

export const MenuButton = styled.button`
  background: ${({ active }) => (active ? "#34495e" : "transparent")};
  border: none;
  color: white;
  padding: 10px 15px;
  margin: 5px 0;
  text-align: left;
  cursor: pointer;
  width: 100%;
  border-radius: 4px;
  &:hover {
    background: #3d566e;
  }
`;



export const DashboardPlaceholder = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #7f8c8d;
`;

export const CustomFooter = styled.footer`
  background-color: #ffffff;
  color: red;
  font-weight: bold;
  padding: 8px 16px;
  text-align: center;
  font-size: 14px;
  border-top: 3px solid red;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
